import { getStarted_FlexPane_Title } from 'owa-locstrings/lib/strings/getstarted_flexpane_title.locstring.json';
import { whatsNew_FlexPane_Title } from 'owa-locstrings/lib/strings/whatsnew_flexpane_title.locstring.json';
import { UpgradeMessage } from 'owa-locstrings/lib/strings/upgrademessage.locstring.json';
import { timePanelHeaderText } from '../strings.locstring.json';
import { todoCharm_ariaLabel } from 'owa-locstrings/lib/strings/todocharm_arialabel.locstring.json';
import { skypeCharm_ariaLabel } from 'owa-locstrings/lib/strings/skypecharm_arialabel.locstring.json';
import { skypeEnterpriseCharm_ariaLabel } from 'owa-locstrings/lib/strings/skypeenterprisecharm_arialabel.locstring.json';
import { settingsCharm_ariaLabel } from 'owa-locstrings/lib/strings/settingscharm_arialabel.locstring.json';
import { helpCharm_ariaLabel } from 'owa-locstrings/lib/strings/helpcharm_arialabel.locstring.json';
import { feedbackCharm_ariaLabel } from 'owa-locstrings/lib/strings/feedbackcharm_arialabel.locstring.json';
import { activityFeedTitle } from 'owa-locstrings/lib/strings/activityfeedtitle.locstring.json';
import loc from 'owa-localize';
import React from 'react';
import * as ReactDOM from 'react-dom';
import { observer } from 'mobx-react';
import { TodoCharmKey } from 'owa-header/lib/components/TodoCharm';

import { ControlIconsDefinitions } from 'owa-control-icons/lib/data/controlIconsRegistration';
import GetStartedCharm from 'owa-header/lib/components/GetStartedCharm';
import WhatsNewCharm from 'owa-header/lib/components/WhatsNewCharm';
import { ShellControl } from '@suiteux/suiteux-shell-react';
import DiagnosticsCharm from 'owa-header/lib/components/DiagnosticsCharm';
import toggleCharm from 'owa-header-store/lib/actions/toggleCharm';
import HeaderCharmType from 'owa-header-store/lib/store/schema/HeaderCharmType';
import PremiumOlkCharm from 'owa-header/lib/components/PremiumOlkCharm';
import { openPremiumDashboard } from 'owa-whats-new';
import { TimePanelCharmKey } from 'owa-header/lib/components/TimePanelCharm';
import { ActivityFeedCharmStub, SkypeCharmStub } from 'owa-header/lib/components/charmStubs';

const owaHeaderStyles = require('owa-header/lib/components/Header.scss');
export const owaIconFontFamily = 'controlIcons';

const charmContainers = {};

interface OwaSuiteHeaderButtonState {
    searchMode?: boolean;
}

@observer
export default class OwaSuiteHeaderButton extends React.Component<{}, OwaSuiteHeaderButtonState> {
    render() {
        return (
            <div className={this.state && this.state.searchMode && owaHeaderStyles.inSearch}>
                {this.props.children}
            </div>
        );
    }
}

const featureFlagsLabel = 'Feature Flags'; // No need to localize as it is a DEV feature only
export const OwaFeatureFlagsButtonID: string = 'owaFeatureFlagsButton';
export const OwaFeatureFlagsButton = {
    id: 'owaFlagBtn',
    headerButtonRenderData: {
        id: OwaFeatureFlagsButtonID,
        iconFontName: ControlIconsDefinitions.Flag,
        iconFontFamily: owaIconFontFamily,
        ariaLabel: featureFlagsLabel,
        affordanceMenuItemText: featureFlagsLabel,
    },
} as ShellControl;

const premiumLabel = () => loc(UpgradeMessage);
export const OwaPremiumButtonID: string = 'owaPremiumButton';
export const OwaPremiumButton = createChildControlFromCharm(
    'owaPremiumLabel',
    <PremiumOlkCharm />,
    ControlIconsDefinitions.Diamond,
    premiumLabel,
    premiumLabel,
    openPremiumDashboard
);

const todoLabel = () => loc(todoCharm_ariaLabel);
export const OwaToDoButtonID: string = TodoCharmKey;
export const OwaToDoButton = {
    id: 'owaToDoBtn',
    headerButtonRenderData: {
        id: OwaToDoButtonID,
        iconFontName: ControlIconsDefinitions.ToDoLogoOutline,
        iconFontFamily: owaIconFontFamily,
        ariaLabel: todoLabel,
        affordanceMenuItemText: todoLabel,
    },
} as ShellControl;

const timePanelLabel = () => loc(timePanelHeaderText);
export const OwaTimePanelButtonID: string = TimePanelCharmKey;
export const OwaTimePanelButton = {
    id: 'owaTimePanelBtn',
    headerButtonRenderData: {
        id: OwaTimePanelButtonID,
        iconFontName: ControlIconsDefinitions.EventToDoLogo,
        iconFontFamily: owaIconFontFamily,
        ariaLabel: timePanelLabel,
        affordanceMenuItemText: timePanelLabel,
    },
} as ShellControl;

const settingsLabel = () => loc(settingsCharm_ariaLabel);
export const OwaSettingsButtonID: string = 'owaSettingsButton';
export const OwaSettingsButton = {
    id: 'owaSettingsBtn',
    headerButtonRenderData: {
        id: OwaSettingsButtonID,
        iconFontName: ControlIconsDefinitions.Settings,
        iconFontFamily: owaIconFontFamily,
        ariaLabel: settingsLabel,
        affordanceMenuItemText: settingsLabel,
    },
} as ShellControl;

const feedbackLabel = () => loc(feedbackCharm_ariaLabel);
export const OwaFeedbackButtonID: string = 'owaFeedbackButton';
export const OwaFeedbackButton = {
    id: 'owaFeedbackBtn',
    headerButtonRenderData: {
        id: OwaFeedbackButtonID,
        iconFontName: ControlIconsDefinitions.Emoji2,
        iconFontFamily: owaIconFontFamily,
        ariaLabel: feedbackLabel,
        affordanceMenuItemText: feedbackLabel,
    },
} as ShellControl;

const getStartedKey = 'getstarted';
const getStartedLabel = () => loc(getStarted_FlexPane_Title);
export const OwaGetStartedButtonID: string = 'getstarted';
export const OwaGetStartedButton = createChildControlFromCharm(
    getStartedKey,
    <GetStartedCharm key={getStartedKey} />,
    ControlIconsDefinitions.Lightbulb,
    getStartedLabel,
    getStartedLabel
);

const whatsNewKey = 'whatsnew';
const whatsNewLabel = () => loc(whatsNew_FlexPane_Title);
export const OwaWhatsNewButtonID: string = 'whatsnew';
export const OwaWhatsNewButton = createChildControlFromCharm(
    whatsNewKey,
    <WhatsNewCharm key={whatsNewKey} />,
    ControlIconsDefinitions.Megaphone,
    whatsNewLabel,
    whatsNewLabel
);

const chatKey = 'skype';
const businessChatLabel = () => loc(skypeEnterpriseCharm_ariaLabel);
export const OwaBusinessChatButton = createChildControlFromCharm(
    chatKey,
    <SkypeCharmStub key={chatKey} />,
    ControlIconsDefinitions.OfficeChat,
    businessChatLabel,
    businessChatLabel
);

const consumerChatLabel = () => loc(skypeCharm_ariaLabel);
export const OwaConsumerChatButton = createChildControlFromCharm(
    chatKey,
    <SkypeCharmStub key={chatKey} />,
    ControlIconsDefinitions.SkypeLogo,
    consumerChatLabel,
    consumerChatLabel
);

const diagnosticsKey = 'diagnostic charm';
const diagnosticsLabel = () => 'Diagnostics'; // No need to localize as it is a DEV feature only
const toggleDiagnosticCharm = () => toggleCharm(HeaderCharmType.DiagnosticsCharm);
export const OwaDiagnosticsButton = (DiagnosticsPanel: React.ComponentType<{}>) =>
    createChildControlFromCharm(
        diagnosticsKey,
        <DiagnosticsCharm key={diagnosticsKey} DiagnosticsPanel={DiagnosticsPanel} />,
        ControlIconsDefinitions.DeveloperTools,
        diagnosticsLabel,
        diagnosticsLabel,
        toggleDiagnosticCharm,
        toggleDiagnosticCharm
    );

export const OwaShellHelpButton = {
    id: 'owaHelpButton',
    nativeControlID: 'HelpIcon',
};

export const OwaHelpButtonID: string = 'owahelp';
const helpButtonLabel = () => loc(helpCharm_ariaLabel);
export const OwaCustomHelpButton = {
    id: OwaHelpButtonID,
    headerButtonRenderData: {
        id: OwaHelpButtonID,
        iconFontName: ControlIconsDefinitions.Help,
        iconFontFamily: owaIconFontFamily,
        ariaLabel: helpButtonLabel,
        affordanceMenuItemText: helpButtonLabel,
    },
};

const activityFeedLabel = () => loc(activityFeedTitle);
export const OwaActivityFeedButtonID: string = 'owaActivityFeedButton';
export const OwaActivityFeedButton = createChildControlFromCharm(
    OwaActivityFeedButtonID,
    <ActivityFeedCharmStub key={OwaActivityFeedButtonID} />,
    ControlIconsDefinitions.Ringer,
    activityFeedLabel,
    activityFeedLabel
);

function createChildControlFromCharm(
    key: React.Key,
    charm: JSX.Element,
    iconCode: string,
    ariaLabel: () => string,
    affordanceMenuItemText: () => string,
    onShow?: (ClientRect) => void,
    onHide?: () => void
): ShellControl {
    return {
        id: key,
        render: (container: HTMLDivElement) =>
            ReactDOM.render(
                <OwaSuiteHeaderButton ref={component => (charmContainers[key] = component)}>
                    {charm}
                </OwaSuiteHeaderButton>,
                container
            ),
        enterSearchMode: (container: HTMLDivElement) =>
            charmContainers[key] && charmContainers[key].setState({ searchMode: true }),
        exitSearchMode: (container: HTMLDivElement) =>
            charmContainers[key] && charmContainers[key].setState({ searchMode: false }),
        responsiveBehavior: {
            responsivePriority: 0,
            minimizeBehavior: 'overflow',
            affordanceBehavior: {
                customButtonRenderData: {
                    id: key,
                    iconFontName: iconCode,
                    iconFontFamily: owaIconFontFamily,
                    onHide: onHide,
                    onShow: onShow,
                    ariaLabel: ariaLabel,
                    affordanceMenuItemText: affordanceMenuItemText,
                },
            },
        },
    } as ShellControl;
}
